module.exports = __webpack_public_path__ + "static/img/banner-0.33b9648.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner-0.jpg
// module id = 847+
// module chunks = 1